// src/components/homepage/PartnersSection.jsx
import React from "react";

const PartnersSection = ({ partners }) => {
  if (!partners || partners.length === 0) {
    return null;
  }

  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* <h2 className="text-2xl font-bold text-center text-gray-800 mb-10">Our Partners</h2> */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-16">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="h-10 sm:h-12 md:h-14 lg:h-16 flex items-center justify-center"
            >
              {partner.url ? (
                <img
                  src={`${partner.url}`}
                  alt={partner.alternativeText || partner.name}
                  className="max-h-full w-auto object-contain transition-all duration-300"
                />
              ) : (
                <div className="text-gray-400">Invalid partner data</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
